<template>
    <b-modal
        title-tag="h2"
        title="Text (SMS) Estimate"
        :lazy="true"
        :visible="isOpen"
        no-close-on-backdrop
        no-close-on-esc
    >
        <b-form-group label-cols="3" label="Mobile:" label-for="mobile">
            <b-row>
                <b-col cols="4" class="pr-0">
                    <country-code
                        :isDisabled="isFetchingData"
                        class="form-control"
                        v-model="data.mobileCountryCode"
                    />
                </b-col>
                <b-col class="pl-1">
                    <b-form-input
                        :disabled="isFetchingData"
                        v-model="data.mobile"
                        :class="{
                            'border-danger': formError.includes('mobile')
                        }"
                        placeholder="Mobile (required)"
                    ></b-form-input>
                </b-col>
            </b-row>
        </b-form-group>

        <b-form-group label-cols="3" label="Message:" label-for="message">
            <b-form-textarea
                :disabled="isFetchingData"
                v-model="data.message"
                placeholder="Message (required)"
                :class="{
                    'border-danger': formError.includes('message')
                }"
                rows="3"
                max-rows="6"
            ></b-form-textarea>
        </b-form-group>

        <b-form-group
            label-for="include_declined"
            label="Declined Items:"
            label-cols="3"
            v-if="isEstimateHasDeclinedItems"
        >
            <b-form-checkbox
                id="include_declined"
                v-model="data.includeDeclined"
                name="include_declined"
                plain
                class="col-form-label"
            >
                <span class="fw-normal">{{
                    TEXT_INCLUDE_DECLINED_ITEMS_ESTIMATE
                }}</span>
            </b-form-checkbox>
        </b-form-group>

        <template v-slot:modal-footer>
            <loader v-if="isLoading" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="onClose"
                v-if="!isLoading"
            >
                Cancel
            </b-button>

            <b-button v-if="!isLoading" variant="primary" @click="send">
                Send
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import CountryCode from "@/module/commons/countrycode.vue";
import EstimateBillingService from "@/services/billing/billing-estimate";
import Loader from "@/module/commons/loader";
import { TEXT_INCLUDE_DECLINED_ITEMS_ESTIMATE } from "@/constants/billings.js";
export default {
    components: {
        CountryCode,
        Loader
    },
    data: function () {
        return {
            formError: [],
            isOpen: false,
            isLoading: false,
            isFetchingData: true,
            isEstimateHasDeclinedItems: false,
            data: {
                estimateId: null,
                mobileCountryCode: null,
                mobile: null,
                message: "",
                reference: null,
                includeDeclined: false
            },
            TEXT_INCLUDE_DECLINED_ITEMS_ESTIMATE
        };
    },
    watch: {
        "data.message"() {
            this.formError = this.formError.filter(err => err !== "message");
        },
        "data.mobile"() {
            this.formError = this.formError.filter(err => err !== "mobile");
        }
    },
    methods: {
        open(estimateId) {
            this.isOpen = true;
            this.data.estimateId = estimateId;
            this.fetchData(estimateId);
        },
        async fetchData(estimateId) {
            let self = this;
            self.isLoading = true;
            self.isFetchingData = true;

            await EstimateBillingService.getEstimateSMSDetail(estimateId)
                .then(res => {
                    if (res && res.resources) {
                        self.data.message = res.resources.message;
                        if (res.resources.mobile) {
                            self.data.mobileCountryCode =
                                res.resources.mobile.code;
                            self.data.mobile = res.resources.mobile.number;
                        }
                        self.data.reference = res.resources.reference;
                        self.isEstimateHasDeclinedItems =
                            res.resources?.has_decline == true;
                    } else {
                        throw new Error("Error: Unable to fetch data.");
                    }
                })
                .catch(e => {
                    self._message("Error: Unable to fetch data.", "danger");
                })
                .finally(() => {
                    self.isLoading = false;
                    self.isFetchingData = false;
                });
        },
        async send() {
            let hasError = false;
            let self = this;
            self.formError = [];

            if (!self.data.mobile || self.data.mobile === "") {
                self.formError.push("mobile");
                hasError = true;
            }

            if (!self.data.message || self.data.message === "") {
                self.formError.push("message");
                hasError = true;
            }

            if (hasError) {
                return;
            }

            let data = {
                estimate_id: self.data.estimateId,
                message: self.data.message,
                number: self.data.mobileCountryCode + self.data.mobile, // "+" already added in barramundi
                reference: self.data.reference,
                include_declined: self.data.includeDeclined
            };
            self.isLoading = true;
            await EstimateBillingService.sendSMS(data)
                .then(res => {
                    if (res.message && res.code == 200) {
                        self._message(
                            res.message || "Message successfully sent."
                        );
                        self.onClose();
                    } else {
                        throw new Error("Error: Unable to send SMS.");
                    }
                })
                .catch(e => {
                    self._message("Error: Unable to send SMS.", "danger");
                })
                .finally(() => {
                    self.isLoading = false;
                });
        },

        resetModalState: function () {
            this.data.mobile = null;
            this.data.mobileCountryCode = null;
            this.data.message = "";
            this.data.estimateId = null;
        },

        onClose() {
            this.resetModalState();
            this.isOpen = false;
        }
    }
};
</script>
